import { Dispatch } from 'react'
import { setCompanyData, setCompanyDataSucceeded, setCompanyDataError, setCompanyDataReset } from './actions'
import { CompanyActions } from './types'
import empresasDataService from '../../services/empresa-data-service'
import loggerService from '../../services/logger-service'

export const getCompanyData = (): any => {
  return async (dispatch: Dispatch<CompanyActions>) => {
    try {
      dispatch(setCompanyData())
      const [companyData, userData] = await Promise.all([
        empresasDataService.getDatosEmpresaLogeada(),
        empresasDataService.getDatosUsario(),
      ])
      const isLogged = !!companyData && !!userData
      dispatch(setCompanyDataSucceeded({ companyData, userData, isLogged }))
    } catch (error) {
      loggerService.logError(`Fetch Company Data: ${error.message}`, error.stack)
      dispatch(setCompanyDataError())
    }
  }
}

export const resetCompanyData = (): any => {
  return (dispatch: Dispatch<CompanyActions>) => {
    dispatch(setCompanyDataReset())
  }
}
